/*
 * FieldToggleSwitchGroup usando FieldCheckbox
 * Solución simple que aprovecha el manejo correcto de arrays de FieldCheckbox
 */
import React from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import { FieldCheckbox, ValidationError } from '../../components';
import { CiCircleInfo } from 'react-icons/ci';
import css from './FieldToggleSwitchGroup.module.css';
import toggleCss from './FieldToggleSwitchGroup.module.css';
import { selectableIcons } from '../../util/selectableIcons';

  const getIconComponent = option => {
    const iconConfig = selectableIcons.find(icon => icon.id === option);
    return iconConfig?.icon || null;
  };


/**
 * Custom component that renders a checkbox input but looks like a toggle switch
 */
const CheckboxAsToggle = props => {
  const {
    id,
    name,
    value,
    label,
    IconComponent,
    infoText,
    disabled,
  } = props;
  return (
    <Field name={name} type="checkbox" value={value}>
      {({ input }) => {
        const checked = input.checked;
        
        return (
          <div className={css.toggleItem}>
            <div className={css.iconLabel}>
             {IconComponent ? <IconComponent className={css.iconField}/> : null}
              <label htmlFor={id} className={toggleCss.description}>
              {label}
            </label>
            </div>
            <label htmlFor={id} className={toggleCss.switch}>
              <input
                {...input}
                id={id}
                type="checkbox"
                className={toggleCss.input}
                disabled={disabled}
              />
              <span className={toggleCss.track} aria-hidden="true">
                <span className={toggleCss.thumb} />
              </span>
            </label>
          </div>
        );
      }}
    </Field>
  );
};

/**
 * Group of toggle switches that store multiple values in an array
 * 
 * @component
 * @param {Object} props
 * @param {string} props.name - Field name (e.g., 'pub_amenities')
 * @param {string} props.id - Base ID for inputs
 * @param {Array} props.options - [{key, label, infoText}]
 * @param {string} [props.label] - Group label
 * @param {boolean} [props.twoColumns] - Two column layout
 * @param {boolean} [props.disabled] - Disable all
 */
const FieldToggleSwitchGroup = props => {
  const {
    className,
    rootClassName,
    label,
    twoColumns,
    id,
    name,
    options,
    disabled,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const listClasses = twoColumns ? classNames(css.list, css.twoColumns) : css.list;
  const Tag = label ? 'fieldset' : 'div';

  return (
    <Tag className={classes}>
      {label ? <legend className={css.legend}>{label}</legend> : null}
      <ul className={listClasses}>
        {options.map(option => {
           const IconComponent = getIconComponent(option.key);
          const fieldId = `${id}.${option}`;
          return (
          
          <li key={fieldId} className={css.item}>
            <CheckboxAsToggle
              id={`${id}.${option.key}`}
              name={name}
              value={option.key}
              label={option.label}
              infoText={option.infoText}
              disabled={disabled}
              IconComponent={IconComponent}
            />
          </li>
        )})}
      </ul>
      <Field name={name}>
        {({ meta }) => <ValidationError fieldMeta={meta} />}
      </Field>
    </Tag>
  );
};

export default FieldToggleSwitchGroup;